import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable({ providedIn: 'root' })
export class AumPaginatorIntl extends MatPaginatorIntl {
    private rangeText: string;
    constructor() {
        super();
    }

    public setRangeText(rangeText: string): void {
        this.rangeText = rangeText;
    }

    override getRangeLabel: (page: number, pageSize: number, length: number) => string = (
        page: number,
        pageSize: number,
        length: number,
    ) => {
        if (length === 0 || pageSize === 0) {
            return `0 - ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;

        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

        return `${startIndex + 1} - ${endIndex} ${this.rangeText} ${length}`;
    };
}
